module.exports = __webpack_public_path__ + "static/media/janio-main-logo.a0d88b6d.png";